// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { OrderTransactionTypeCollectionModel } from "@store/Framework/Types/ApiModels";

export interface GetTransactionTypesApiParameter extends ApiParameter {
    expand?: [];
}

export const getOrderTransactionTypes = async (
    parameter: GetTransactionTypesApiParameter = {},
): Promise<OrderTransactionTypeCollectionModel> => {
    try {
        return await get<OrderTransactionTypeCollectionModel>(
            "/api/v1/custom/orderHistory/transactionTypes",
            parameter,
        );
    } catch (error) {
        console.error("Failed to fetch transaction types:", error); // eslint-disable-line no-console
        throw error;
    }
};
